/**
 * 基础信息-银行管理
 * @author wmz
 * @date 2021-02-27
 */
import request from '@/utils/request'

export function getBankAssociationNumber(query) {
  return request({
    url: `/ntocc-basic-api/bankCard/getBankAssociationNumber`,
    method: 'get',
    params: query
  })
}
// 绑卡操作 
export function bindBankCard(code) {
  return request({
    url: `/ntocc-basic-api/bankCard/bindBankCard/${code}`,
    method: 'post',
  })
}
// 解绑操作
export function unBindBankCard(code) {
  return request({
    url: `/ntocc-basic-api/bankCard/unBindBankCard/${code}`,
    method: 'post',
  })
}
// 新增银行类型
export function dict(query) {
  return request({
    url: '/ntocc-basic-api/dict',
    method: 'get',
    params: query
  })
}

export function getPublicBankAssociationNumber(query) {
  return request({
    url: `/ntocc-basic-api/bankCard/public/getBankAssociationNumber`,
    method: 'get',
    params: query
  })
}
